import { SkyAvatar, type AvatarSize } from "@skypointcloud/skypoint-ui";
import { useAuthenticatedImage } from "@/hooks/useAuthenticatedImage";

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export interface EmployeeAvatarProps {
  name: string;
  /** The person's photo endpoint; loaded with the bearer token, as <img> can't send one. */
  photoUrl: string | null;
  size?: AvatarSize;
}

/**
 * A person's photo when they have one, otherwise their initials. The WLM
 * PersonAvatar is left as it is; this one knows about skyEmployee photos.
 */
export function EmployeeAvatar({ name, photoUrl, size = 40 }: EmployeeAvatarProps) {
  const src = useAuthenticatedImage(photoUrl);
  return (
    <SkyAvatar
      name={initials(name)}
      size={size}
      color="brand"
      {...(src ? { image: { src, alt: name } } : {})}
    />
  );
}
